"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.BuildTableProps = BuildTableProps;
exports.GetTableState = GetTableState;
exports.ProcessTableData = ProcessTableData;
exports.TableProps = TableProps;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _immutable = _interopRequireDefault(require("immutable"));
var _immutableHelpers = require("./immutableHelpers");
function BuildTableProps(tableId, tableDef, store, rawTableData, filterEntity) {
  if (!rawTableData) {
    if (tableDef.useFilterEntity && filterEntity) {
      rawTableData = filterEntity(store, tableDef.entity).toIndexedSeq().toList();
    } else {
      rawTableData = (tableDef.dataStorePath ? store.getIn(tableDef.dataStorePath) : store.getIn(['entities', tableDef.entity])).toIndexedSeq().toList();
    }
  }
  return TableProps(rawTableData, tableId, tableDef, store);
}
function TableProps(seqOfMaps, tableId, tableDef, store) {
  var _context, _context2;
  let tableState = GetTableState(tableId, store, tableDef);
  // Only the columns we care about
  const wantedColumns = [];
  (0, _forEach.default)(_context = tableDef.columnDefs).call(_context, x => {
    wantedColumns.push(x.property);
    if (x.isLink) {
      wantedColumns.push(x.isLink.idProperty);
    }
  });
  return {
    tableId,
    tableData: (0, _map.default)(_context2 = ProcessTableData(seqOfMaps, tableState, tableDef)).call(_context2, row => (0, _filter.default)(row).call(row, (0, _immutableHelpers.keyIn)(...wantedColumns))),
    tableDef,
    tableState
  };
}
function ProcessTableData(tableData, tableState, tableDef) {
  let columnDefs = tableDef.columnDefs;
  let direction = (0, _sort.default)(tableState).direction;
  let column = (0, _sort.default)(tableState).columnId;
  let columnSpec = column.split('.');
  const filteredTableData = _immutable.default.List().asMutable();
  for (let a of tableData) {
    if (!(0, _filter.default)(tableState)) {
      filteredTableData.push(a);
      continue;
    }
    let curVal = a.toJS();
    for (var i = 0; i < columnDefs.length; i++) {
      var _context3;
      let columnDef = columnDefs[i];
      let columnVal = curVal[columnDef.property];
      if (columnDef.searchable && columnVal && (0, _indexOf.default)(_context3 = columnVal.toString().toLowerCase()).call(_context3, (0, _filter.default)(tableState)) > -1) {
        //stop processing on the first hit.
        filteredTableData.push(a);
        continue;
      }
    }
  }
  return (0, _sort.default)(filteredTableData).call(filteredTableData, (a, b) => {
    let aVal = a.getIn(columnSpec, 0);
    let bVal = b.getIn(columnSpec, 0);
    let multiplier = direction == "down" && 1 || direction == "up" && -1 || 0;
    if (aVal > bVal || bVal === null) {
      return -multiplier;
    } else if (aVal < bVal || aVal === null) {
      return multiplier;
    } else {
      return 0;
    }
  }).asImmutable();
}
function GetTableState(tableId, store, tableDef) {
  let storePath = ['tableState', tableId];
  let curState = {};
  if (store.hasIn(storePath)) {
    curState = store.getIn(storePath).toJS();
  }

  //map the current state on top of the defaults
  return (0, _assign.default)({
    sort: (0, _sort.default)(tableDef),
    filter: (0, _filter.default)(tableDef)
  }, curState);
}